import { ListViewItem } from '@ingka/list-view';
import Text from '@ingka/text';
import type { AssetMessage } from '@repo/types/messages';
import { formatDateTime } from '@repo/utils';

import styles from './styles.module.scss';

type TranslateFunction = (key: string, params?: Record<string, string>) => string;

interface MessageItemProps {
    message: AssetMessage;
    translate: TranslateFunction;
    dateTimeFormat: string;
    enableEdit: boolean;
    onMessageClick: (message: AssetMessage) => void;
}

export const MessageItem = ({ message, translate, dateTimeFormat, enableEdit, onMessageClick }: MessageItemProps) => {
    const formattedDateTime = message.createDateTime
        ? formatDateTime(message.createDateTime, dateTimeFormat)
        : undefined;

    return (
        <ListViewItem
            emphasised
            title={
                message.createDateTime && formattedDateTime ? (
                    <time dateTime={message.createDateTime} aria-label={translate('messages_modal_created_at')}>
                        {formattedDateTime}
                    </time>
                ) : undefined
            }
            description={
                <Text tagName="p" textStyle="Body.M">
                    {message.messageText}
                </Text>
            }
            addOn={
                message.createdUserId ? (
                    <Text tagName="p" textStyle="Body.M">
                        {translate('messages_modal_created_by', {
                            user: message.createdUserId,
                        })}
                    </Text>
                ) : undefined
            }
            className={String(styles.message)}
            showDivider
            {...(enableEdit &&
                message.orderMessageId && {
                    control: 'navigational',
                    controlIcon: 'chevronRight',
                    onClick: () => {
                        onMessageClick(message);
                    },
                })}
        />
    );
};
